export default "__VITE_ASSET__DpCmRChW__"